import type { FC, ReactNode } from 'react'

import { delay } from '@/lib/ui'
import { SplitWords } from '@/components/generals/split-words'
import { ABOUT_METHOD } from '@/constants/about'

export const AboutStatement: FC = (): ReactNode => {
    return (
        <>
            <section id='position' className='ed-wrap pt-[clamp(48px,6vh,84px)]'>
                <div className='grid gap-y-6 md:grid-cols-12 md:gap-x-[clamp(20px,3vw,48px)]'>
                    <div className='md:col-span-4'>
                        <div className='ed-label' data-reveal='up'>
                            (02) — Position
                        </div>
                    </div>

                    <div className='md:col-span-8'>
                        <h2 className='ed-h2' data-reveal='words'>
                            <SplitWords text='We are not in the business of nice weather' />
                        </h2>
                    </div>
                </div>

                <div className='mt-[clamp(32px,5vh,64px)] grid gap-y-8 md:grid-cols-12 md:gap-x-[clamp(20px,3vw,48px)]'>
                    <div className='md:col-span-5 md:col-start-4'>
                        <p className='ed-body' data-reveal='up'>
                            The pictures that last are almost never the pretty ones. A flat pink sea at dawn is
                            a gift, but it is the six greys of a fogged-out beach that people come back to and
                            keep looking at. So we shoot for structure first: where the ground goes, what the
                            water is doing to it, and how far you can see before the air takes over.
                        </p>
                    </div>

                    <div className='md:col-span-4'>
                        <p className='ed-body' data-reveal='up' style={delay(0.1)}>
                            That means most trips fail, and we plan for it. A commission is quoted with the
                            failures priced in, because a schedule that assumes the light will cooperate is a
                            schedule that produces stock photography.
                        </p>

                        <p className='ed-body' data-reveal='up' style={delay(0.18)}>
                            What we hand over is a small number of frames that are genuinely about something,
                            and a print that will still be worth hanging in thirty years.
                        </p>
                    </div>
                </div>
            </section>

            <section id='method' className='ed-wrap pt-[clamp(48px,6vh,84px)]'>
                <div className='ed-label mb-[clamp(20px,3.2vh,40px)]' data-reveal='up'>
                    (03) — Method
                </div>

                <div>
                    {ABOUT_METHOD.map((step, index) => (
                        <article
                            key={step.index}
                            className='ed-row grid-cols-1 md:grid-cols-[92px_minmax(0,1fr)_minmax(0,1.2fr)] md:gap-x-[clamp(20px,3vw,48px)]'
                            data-reveal='up'
                            style={delay(index * 0.07)}
                        >
                            <span className='ed-mono text-faint'>
                                {step.index}
                            </span>

                            <h3 className='ed-h3'>
                                {step.title}
                            </h3>

                            <p className='ed-body'>
                                {step.body}
                            </p>
                        </article>
                    ))}
                </div>
            </section>
        </>
    )
}
